// extracted by mini-css-extract-plugin
export default {"formContainer":"EditVideoPage_formContainer__AbK5c","ipnutGroup":"EditVideoPage_ipnutGroup__fWhUh"};